import React from 'react';
import SMFormCheckBoxWithError from 'components/dashboard/form/SMFormCheckBoxWithError';

class SMOBusinessDayView extends React.Component {
  
  render() {
    let business_days = [];

    if (this.props.model.business_days) {
      for (var i=0; i < I18n.t('date.abbr_day_names').length; i++) {
        let check = false;
        for (var j=0; j < this.props.model.business_days.length; j++) {
          if (this.props.model.business_days[j] == i) {
            check = true;
            break;
          }
        }
        business_days.push({label:I18n.t('date.day_names')[i], value:i, checked:check});
      }
    } else {
      for (var i=0; i < I18n.t('date.day_names').length; i++) {
        business_days.push({label:I18n.t('date.day_names')[i], value:i, checked:false});
      }
    }
    
    return (
      <SMFormCheckBoxWithError name='business_days[]'
        postHiddenData={false} 
        items={business_days} 
        delegate={this.props.delegate} />
    );
  }
}
export default SMOBusinessDayView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/rooms/fragments/SMOBusinessDayView.jsx